import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { db_tables, features, routes } from '@app/consts';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { TablePermissionsService } from '@app/core/services/table-permissions/table-permissions.service';
import { EmployeeTableSecurity } from '@app/shared/models/employee.model';
import { modules } from '@app/consts/modules';

@Component({
  selector: 'app-employee-time-off',
  templateUrl: './employee-time-off.component.html',
  styleUrls: ['./employee-time-off.component.scss']
})
export class EmployeeTimeOffComponent implements OnInit {
  navList;
  selectedComponent: string;
  employeeId: string;
  subSection: string = 'TimeOffHistory';
  isLoading: boolean;
  targetEmployeeTablePermissions: EmployeeTableSecurity[] = [];

  constructor(
    public translate: TranslateService,
    private route: ActivatedRoute,
    public router: Router,
    private location: Location,
    private tablePermissionsService: TablePermissionsService,
  ) { }

  ngOnInit(): void {
    this.employeeId = this.getIdInURL();
    this.subSection = this.getSubSectionInURL() || this.subSection;
    this.setSubSectionInUrl(this.subSection);
    this.getTargetEmployeeTablePermissions();
  }

  getIdInURL(): string {
    let IdInURL: string;

    this.route.paramMap.subscribe(
      params => IdInURL = params.get("id")
    )

    return IdInURL;
  }

  getTargetEmployeeTablePermissions() {
    this.isLoading = true;

    this.tablePermissionsService.getTargetEmployeeTablePermissions(this.employeeId)
      .subscribe({
        next: (response) => {
          this.isLoading = false;
          this.targetEmployeeTablePermissions = response;
          this.buildNavList();
        },
        error: (error) => {
          this.isLoading = false;
        }
      });
  }

  buildNavList() {
    let navList = [
      {
        text: 'EmployeeTimeOff-TimeOffHistory',
        route: 'TimeOffHistory',
        module: modules.TIME_OFF,
        feature: 'allow',
        tableAccess: {
          tableId: db_tables.ABSENCES,
          permission: 'read',
          targetEmployeeTablePermissions: this.targetEmployeeTablePermissions
        },
      },
      {
        text: 'EmployeeTimeOff-TOIL',
        route: 'TOIL',
        module: modules.TOIL,
        feature: 'allow',
        tableAccess: {
          tableId: db_tables.TOIL,
          permission: 'read',
          targetEmployeeTablePermissions: this.targetEmployeeTablePermissions
        },
      },
      {
        text: 'EmployeeTimeOff-BuySell',
        route: 'BuySell',
        module: 'allow',
        feature: features.BUY_SELL_USER
      }
    ];

    this.navList = navList.filter(item => {
      let hasAccess = false;

      if (!item.tableAccess) {
        return true;
      }

      switch (item.tableAccess?.permission) {
        case 'update':
          hasAccess = this.tablePermissionsService.hasUpdatePermission(item.tableAccess.tableId, item.tableAccess.targetEmployeeTablePermissions);
          break;
        case 'create':
          hasAccess = this.tablePermissionsService.hasCreatePermission(item.tableAccess.tableId, item.tableAccess.targetEmployeeTablePermissions);
          break;
        case 'delete':
          hasAccess = this.tablePermissionsService.hasDeletePermission(item.tableAccess.tableId, item.tableAccess.targetEmployeeTablePermissions);
          break;
        case 'read':
          hasAccess = this.tablePermissionsService.hasReadPermission(item.tableAccess.tableId, item.tableAccess.targetEmployeeTablePermissions);
      }

      return hasAccess !== false;
    });

    // if (this.navList.length > 0) {
    //   this.setSubSectionInUrl(this.navList[0].route);
    // }
  }


  getSubSectionInURL(): string {
    let subSectionInURL: string;
    
    this.route.paramMap.subscribe(
      params => subSectionInURL = params.get("subSection")
    )
      
    return subSectionInURL;
  }

  setSubSectionInUrl(subSection: string): void {
    this.location.replaceState(`TalentTrack/Edit/${this.employeeId}/TimeOff/${subSection}`);
    this.subSection = subSection;
  }
}
